import React from "react";
import {
  cardStyle,
  titleBox,
  title,
  cardBox,
  reportIconDiv,
  reportTitleBox,
  headingStyle
} from "./style.js";
import ReportsIcon from "../../../components/Menu/MenuIcons/ReportsIcon.js";
import {BMTheme} from "../../../BMTheme.js";
import { translate } from "admin-on-rest";

class ReportDataList extends React.Component {

  handleOnClick(resource) {
    this.props.history.push(resource);
  }

  render() {
    const {translate} = this.props;
    
    return (
      <React.Fragment>
        <div style={titleBox}>
          <h1 style={title}>{translate("resources.reports.mainReportsPageTitle")}</h1>
        </div>
        
        <div style={cardBox} onClick={() => {
          this.handleOnClick('/reporting/customer_registration');
        }}>
          <div style={cardStyle}>
            <div style={reportIconDiv}>
              <ReportsIcon color={BMTheme.icons.color}/>
            </div>
            <div style={reportTitleBox}>
              <p style={headingStyle}>{translate("resources.reports.customerReportsTitle")}</p>
            </div>
          </div>
        </div>

        <div style={cardBox} onClick={() => {
          this.handleOnClick('/reporting/gift_cards');
        }}>
          <div style={cardStyle}>
            <div style={reportIconDiv}>
              <ReportsIcon color={BMTheme.icons.color}/>
            </div>
            <div style={reportTitleBox}>
              <p style={headingStyle}>{translate("resources.reports.giftCardsReportsTitle")}</p>
            </div>
          </div>
        </div>

        <div style={cardBox} onClick={() => {
          this.handleOnClick('/reporting/all_customer_phones');
        }}>
          <div style={cardStyle}>
            <div style={reportIconDiv}>
              <ReportsIcon color={BMTheme.icons.color}/>
            </div>
            <div style={reportTitleBox}>
              <p style={headingStyle}>{translate("resources.reports.customerPhonesReportsTitle")}</p>
            </div>
          </div>
        </div>

        <div style={cardBox} onClick={() => {
          this.handleOnClick('/reporting/all_customer_emails');
        }}>
          <div style={cardStyle}>
            <div style={reportIconDiv}>
              <ReportsIcon color={BMTheme.icons.color}/>
            </div>
            <div style={reportTitleBox}>
              <p style={headingStyle}>{translate("resources.reports.customerEmailsReportsTitle")}</p>
            </div>
          </div>
        </div>

        <div style={cardBox} onClick={() => {
          this.handleOnClick('/reporting/cashbacker_campaign_registrations');
        }}>
          <div style={cardStyle}>
            <div style={reportIconDiv}>
              <ReportsIcon color={BMTheme.icons.color}/>
            </div>
            <div style={reportTitleBox}>
              <p style={headingStyle}>{translate("resources.reports.cashbackerCampaignRegistrationsReportsTitle")}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default translate(ReportDataList);


// WEBPACK FOOTER //
// ./src/containers/CRM/DataReports/ReportDataList.js